import React from 'react';
import { Button } from '@/components/ui/button';
import { useCookieConsent } from '@/context/CookieConsentContext';

interface CookieSettingsProps {
  className?: string;
}

const CookieSettings: React.FC<CookieSettingsProps> = ({ className = '' }) => {
  const { resetConsent } = useCookieConsent();

  const handleOpenSettings = () => {
    resetConsent();
  };

  return (
    <Button
      onClick={handleOpenSettings}
      variant="ghost"
      size="sm"
      className={`text-[#6C4F77] hover:text-[#F4978E] hover:bg-transparent p-0 h-auto underline text-[16px] ${className}`}
    >
      Cookie Settings
    </Button>
  );
};

export default CookieSettings;
